import { render, staticRenderFns } from "./DefinedLink.vue?vue&type=template&id=6486e1ca&scoped=true&"
import script from "./DefinedLink.vue?vue&type=script&lang=js&"
export * from "./DefinedLink.vue?vue&type=script&lang=js&"
import style0 from "./DefinedLink.vue?vue&type=style&index=0&id=6486e1ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486e1ca",
  null
  
)

export default component.exports